import { c as _c } from "react/compiler-runtime";
import { LayoutFAQs } from "@/components/terra/layouts/LayoutFAQs/LayoutFAQs";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { createRichTextOptions } from "@/lib/formatters/formatRichText";
import { DEFAULT_PUBLIC_LANG } from "@/lib/locale/toContentfulLocale";
export default function MXPEmbeddedSectionFaqs(props) {
  const $ = _c(7);
  const {
    value,
    lang: t0
  } = props;
  const lang = t0 === undefined ? DEFAULT_PUBLIC_LANG : t0;
  let t1;
  if ($[0] !== lang || $[1] !== value?.faqItemsCollection?.items) {
    const richTextOptions = createRichTextOptions(lang);
    t1 = (value?.faqItemsCollection?.items ?? []).filter(Boolean).map(item => ({
      headline: item.question || "",
      description: item.answer?.json ? documentToReactComponents(item.answer.json, richTextOptions) : ""
    }));
    $[0] = lang;
    $[1] = value?.faqItemsCollection?.items;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const faqItems = t1;
  const t2 = value?.header;
  const t3 = value?.sectionFaqsDescription;
  let t4;
  if ($[3] !== faqItems || $[4] !== t2 || $[5] !== t3) {
    t4 = <LayoutFAQs header={t2} description={t3} faqItems={faqItems} faqType="t2-collapsed" isEmbedded={true} isWrapped={true} />;
    $[3] = faqItems;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}